export default function fancybox() {
    if(document.querySelector("[data-fancybox='gallery-mobile']")){
        Fancybox.bind("[data-fancybox='gallery-mobile']", {
            Thumbs: {
                type: "classic",
            },
        });
    }

    if(document.querySelector("[data-fancybox='gallery-desktop']")){
        Fancybox.bind("[data-fancybox='gallery-desktop']", {
            Thumbs: {
                type: "classic",
            },
        });
    }

    if(document.querySelector("[data-fancybox='video']")){
        Fancybox.bind("[data-fancybox='video']", {
            Thumbs: {
                type: "classic",
            },
        });
    }

    if(document.querySelector("[data-fancybox='details']")){
        Fancybox.bind("[data-fancybox='details']", {
            Thumbs: {
                type: "classic",
            },
        });
    }
}